// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"0ba132b8","232":"fbc0bb1c","236":"98efbe28","744":"8e5a3515"}[chunkId] + ".chunk.css";
};